import React,{useEffect,useState} from 'react'

import {useParams} from 'react-router-dom'
import Product from '../components/Product'
import classes from '../styles/Products.module.scss'
import axios from 'axios'
import { selectProductsData, storeProducts, selectisGenderSwitched, switchGender } from '../redux/features/productSlice'
import { useSelector } from 'react-redux'

const Category = () => {
  
    let {category} = useParams()
    let {gender} = useParams()
    const [products, setproducts] = useState([])
    let productsData= useSelector(selectProductsData)

    const readChildCategory = async ()=>{
        
        //console.log("click function readChildCategory")
        const {data}=await axios.get(`${process.env.REACT_APP_BACKEND_URL+"products/childcategory/"}`,
            {
                params:{
                    gender: gender,
                    category: category,
                }
                    
            },
        )
        setproducts(data)
    }

    useEffect(() => {
        document.title = gender.charAt(0).toUpperCase()+gender.substring(1) + " " + category + " - Velocity Prime"
  

        if (productsData.length > 0){
            setproducts(productsData)
        }else{
            readChildCategory()
        }
    }, [category,gender,productsData])

    

    return (
    <>
        {products.length > 0 ? (
        products.map((product, index) => (
            <Product
            key={index}
            product={product}
            sendDataToParent={null}
            />
        ))
        ) : (
        <div>No {category} for {gender} yet!</div>
        )}
    </>
)   ;
}

export default Category
